import * as R from 'ramda';
import { ActionType } from '../core/redux/actionType';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../core/api/module';
import { Endpoints } from '../core/api/endpoints';
import { Message } from './models';
import { toMap } from '../language/arrays';


const KEY_ACTION = ActionType.LoadTranslationsRequest;
const ACTIONS    = [
  ActionType.LoadTranslationsRequest,
  ActionType.LoadTranslationsResponse,
  ActionType.LoadTranslationsError,
];


type Payload = Message[];


type Meta = {
  languageId: number;
}


/**
 * Dispatch this action to load the translations for the given language from the internet
 */
export const loadTranslationsAction = (appRoot: string, languageId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.PortalMessages,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ languageId: languageId, root: appRoot }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { languageId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, languageId),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, action.meta.languageId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, action.meta.languageId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  const translations = toMap((payload || []), item => item.key);

  return R.assocPath(
    ['locale', 'translations', `${R.head(payload || [])?.languageId}`],
    translations,
    successState,
  );
};


export const loadTranslationsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
